import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { chatList } from "modules/actions/chat";
import IconButton from "components/atoms/Button/IconButton";
import FooterButton from "components/atoms/Button/FooterButton";
import {
  autoCompleteList,
  autoCompleteReset,
  autoCompleteDisplay,
  setCursor,
} from "modules/actions/autoComplete";
import {
  isActiveQuickMenu,
  disableAllMenu,
  isActiveSettingMenu,
  isActiveSideMenu,
} from "modules/actions/statusMenu";
import ChatMenu from "components/molecules/ChatMenu";
import AutoComplete from "components/molecules/AutoComplete";
import { debounce } from "lib";

/**
 * Chatting:Footer
 */

const ChatFooter = () => {
  /** 입력창 Ref */
  const dispatch = useDispatch();

  const inputTextRef = useRef();
  // const hiddenInputRef = useRef();

  const sentenceList = useSelector((state) => state.autoComplete.sentenceList);
  const settingMenuStatus = useSelector((state) => state.isActive.settingMenu);
  const sideMenuStatus = useSelector((state) => state.isActive.sideMenu);
  const quickMenuStatus = useSelector((state) => state.isActive.quickMenu); // [j] : quickMenuStatus 상태 자식 컴포넌트 안으로  
  const status = useSelector((state) => state.isActive.quickMenu);          // [!] : 쓰이는 부분 quickMenuStatus 변수로 변경후 삭제 요망.
  const [textValue, setTextValue] = useState("");
  const [visible, setVisible] = useState(true);

  const autoRef = useRef([]);
  
  const altRemove = () => {
    const btnDiv = document.querySelector('._button_div');
    if (btnDiv) { 
      document.querySelector('._button_div img').setAttribute('alt', '');
    }
  };

  const handleInput = debounce(() => {
    if (!inputTextRef.current) return null;
    const text = inputTextRef.current.value.trim();
    setTextValue(text);
    // if (text === '') {
    //   clearInputTextRef();
    // }
    dispatch(autoCompleteList(text));
  }, 200);

  const onSettingMenu = () => {    
    dispatch(isActiveQuickMenu());
      setVisible(!visible);
  
      if (settingMenuStatus) {
        dispatch(isActiveSettingMenu());
      }
      if (sideMenuStatus) {
        dispatch(isActiveSideMenu());
      }
  };
 
  const isInitialSound = (char) => {
    const code = char.charCodeAt(0);

    // 숫자(ex.01000000000)
    if (code >= 48 && code <= 57) {
        return true;
    }

     // 영어 문자열 조합(ex.PCR)
    if ((code >= 65 && code <= 90) || (code >= 97 && code <= 122)) {
        if (char.includes("javascript") || char.includes("alert")) {
                return false;
        }
        return true;
    }

    // 함글 문자열 조합:가-힣
    if (code >= 44032 && code <= 55203) {
        return true;
    }
    return false;
  };

  const onKeyPressEvt = (e) => {
    altRemove();
    const value = inputTextRef?.current?.value;
    const initialSoundValue = isInitialSound(value);
    // if (e.key === "Enter" && !e.shiftKey && inputTextRef?.current?.value) {
    if (e.key === "Enter" && !e.shiftKey && inputTextRef?.current?.value && initialSoundValue) {
      onSendMessage();
    }
  };

  const clearInputTextRef = () => {
    inputTextRef.current.value = "";
    setTextValue("");
    dispatch(autoCompleteReset());
    // inputTextRef.current.blur()
    // hiddenInputRef.current.focus();
    inputTextRef.current.focus();
  };

  const onSendMessage = () => {
    const value = inputTextRef?.current?.value;
    const paramSet = {
      inType: "query",
      inStr: value,
      inLabel: value,
      parameters: sessionStorage.getItem("address")
        ? {
            latitude_y: sessionStorage.getItem("latitude_y"),
            longitude_x: sessionStorage.getItem("longitude_x"),
            address: sessionStorage.getItem("address"),
            position_status: "Y",
          }
        : { latitude_y: "", longitude_x: "", position_status: "N" },
    };

    dispatch(chatList(paramSet));
    clearInputTextRef();
  };

  const handleClickOutside = ({ target }) => {
    if (!inputTextRef?.current?.contains(target)) {
      dispatch(autoCompleteDisplay(false));
    }
  };

  useEffect(() => {
    altRemove();
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if(quickMenuStatus) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  },[quickMenuStatus]);
  
  useEffect(() => {
    if (inputTextRef.current) {
      inputTextRef.current.focus();
    }
  }, []);
 
  const onKeyDown = debounce((e) => {
    dispatch(autoCompleteDisplay(true));
    autoRef.current = autoRef.current.filter((i) => i !== null);

    if (e.key === "ArrowUp" && sentenceList.length !== 0) {
      const autoLength = autoRef.current.length;
      if (autoLength !== 0 && autoRef.current[autoLength - 1] !== null) {
        autoRef.current[autoLength - 1].focus();
        dispatch(setCursor(autoLength - 1));
      }
    }
  }, 100);

  return (
    <>
      <footer className="_chat_footer">
        <button
          className="_menu_btn"
          type="button"
          aria-label={visible === true ? '홈' : '닫기'}
          title={visible === true ? '홈메뉴' : '닫기'}
          onClick={onSettingMenu}
        >
          {/* {visible ? <IconButton
            icon="ri-add-line"
            styleDef={{color: '#6B6B6B', fontSize: '29px',}}
            viewStatus=""
            clickEvt={onSettingMenu}
          /> : <IconButton
          icon="ri-add-line"
          styleDef={{color: '#6B6B6B', fontSize: '29px', transform: "rotate(45deg)"}}
          viewStatus=""
          clickEvt={onSettingMenu} />} */}

          {visible ? (
            <FooterButton
              icon="ri-add-line"
              styleDef={{ color: "#6B6B6B", fontSize: "29px" }}
              viewStatus=""
              propName='footer'
            />
          ) : (
            <FooterButton
              icon="ri-add-line"
              styleDef={{
                color: "#6B6B6B",
                fontSize: "29px",
                transform: "rotate(45deg)",
              }}
              viewStatus=""
              propName='footer'
            />
          )}
        </button >

        <ChatMenu
            styleDef={{ height: quickMenuStatus ? "250px" : "0px", display: quickMenuStatus ? "block" : "none" }}
            viewStatus={quickMenuStatus}
        /> 

        <div className="_send_div">
          <div className="_send_box">
            <input
              type="text"
              placeholder="메시지를 입력해주세요."
              aria-label="챗봇에게 메시지를 입력해주세요"
              title="챗봇에게 메시지를 입력해주세요"
              autoComplete="off"
              ref={inputTextRef}
              onKeyDown={onKeyDown}
              onKeyPress={onKeyPressEvt}
              onKeyUp={handleInput}
              spellCheck={false}
              className="_send_box_input"
              onClick={() => {
                dispatch(setCursor(""));
              }}
              onFocus={() => {
                // dispatch(disableAllMenu());
                dispatch(autoCompleteDisplay(true));
              }}
              // onBlur={e => {
              //   setTimeout(() => {
              //     dispatch(autoCompleteDisplay(false));
              //   }, 100);
              // }}
            />
            <div
              className="_icon_set"
              onKeyPress={onKeyPressEvt}
            >
              {/* 전송버튼 */}
              <IconButton
                icon={
                  textValue
                    ? `${process.env.PUBLIC_URL}/images/svg/send_active.svg` 
                    : `${process.env.PUBLIC_URL}/images/svg/send_nonActive.svg`
                }
                styleDef={{
                  borderRadius: "40px",
                  border: "0px",
                  //   backgroundColor: textValue ? '#0061AF' : '#999',
                  cursor: textValue ? "pointer" : "default",
                  color: "#BCBCBC",
                  fontSize: "25px",
                  width: "21px",
                }}
                viewStatus=""
                clickEvt={isInitialSound(textValue) ? onSendMessage : () => {}}
                propName='sendBtn'
                alt=""
              />
            </div>
          </div>
        </div>
        <AutoComplete
          clearInputTextRef={clearInputTextRef}
          pointer={autoRef.current}
          inputPtr={inputTextRef}
        />
      </footer>

      {/* <div className="_quick_opacity" style={{ display: status ? 'block' : 'none' }} onClick={() => onClickOut()} /> */}
      {/*  <ChatMenu styleDef={{ height: status ? "250px" : "0px" }} /> */}

    </>
  );
};

ChatFooter.propTypes = {};
ChatFooter.defaultProps = {};
export default ChatFooter;
